import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantHostService } from './tenant-host.service';
import { HomeRouteService } from './home-route.service';

/**
 * Decides where the root URL ('') lands:
 *  - public apex (no subdomain) => /portal (Become a Tenant + Find a Teacher).
 *  - a tenant subdomain => the signed-in user's landing page (see homeFor), otherwise login.
 */
export const rootRedirectGuard: CanActivateFn = (): UrlTree | Observable<UrlTree> => {
  const router = inject(Router);
  const host = inject(TenantHostService);
  const home = inject(HomeRouteService);

  if (host.isApex()) {
    return router.parseUrl('/portal');
  }

  const signedIn = !!localStorage.getItem('authToken');
  if (!signedIn) return router.parseUrl('/account/login');
  return home.resolve().pipe(map((url) => router.parseUrl(url)));
};
